module.exports = __webpack_public_path__ + "img/2.5e4cc91b.jpg";